import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 150px;

  @media (max-width: 768px) {
    margin-bottom: 80px;
    width: 90%;
  }
`;

const Title = styled.div`
  font-size: 30px;
  display: flex;
  color: #385963;
  font-weight: 600;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 25px;
    margin-bottom: 20px;
    place-self: center;
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    margin-bottom: 20px;
    place-self: center;
    text-align: center;
  }
`;

const CarouselContainer = styled.div`
  position: relative;
  max-width: 100%;
  overflow: hidden;
  margin-top: 20px;
`;

const Slider = styled.div`
  display: flex;
  transition: transform 0.6s ease;
`;

// const Slide = styled.div`
//   width: 300px;
//   height: 300px;
//   position: relative;
//   flex-shrink: 0;
//   border-radius: 20px;
//   margin-right: 30px;
//   overflow: hidden;
//   transition: transform 0.5s ease;

//   &:hover {
//     transform: translateY(-5px);
//     cursor: pointer;
//   }
// `;


const Slide = styled.div`
  width: 300px;
  height: 300px;
  position: relative;
  flex-shrink: 0;
  border-radius: 20px;
  margin-right: 30px;
  overflow: hidden;
  transition: transform 0.5s ease;

  &:hover {
    transform: translateY(-5px);
    cursor: pointer;
  }

  @media (max-width: 1024px) {
    width: 250px;
    height: 250px;
    margin-right: 20px;
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 200px;
    margin-right: 15px;
  }

  @media (max-width: 480px) {
    width: 160px;
    height: 160px;
    margin-right: 10px;
  }
`;


const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transition: transform 0.8s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  background: rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 5px;
  text-align: left;
  width: 100%;
  height: 100%;

  h3 {
    font-size: 23px;
    font-weight: 600;
    position: absolute;
    bottom: 40px;
  }

   @media (max-width: 768px) {
    h3{
     font-size: 14px;
     text-align:center;
     place-self:center;
    }
  }
`;

const Button = styled.button`
  background: transparent;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 50%;
  font-size: 24px;
  transition: all 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const Header = styled.div`
   @media (max-width: 768px) {
    display: flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
  }

 
`;

const FILE_PLACE_TYPE = {
  Gallery: 0,
  CategoryPhoto: 1,
  CoverPhoto: 2,
  Poster: 3,
};

const PersonalisedReqs = () => {
  const containerRef = useRef(null);
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const tokenString = sessionStorage.getItem("token");
  const [recommendations, setRecommendations] = useState([]);
  const userRole = sessionStorage.getItem("userRole");

  // const slideWidth = 300;
  // const slideMarginRight = 30;
  // const totalSlideWidth = slideWidth + slideMarginRight;

  const [containerWidth, setContainerWidth] = useState(0);
  const [visibleSlidesCount, setVisibleSlidesCount] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);



useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}RegisteredUserProfile/getPersonalizedRecommendations`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${tokenString}`,
            },
          }
        );

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        const recommendations = data.recommendations || [];

        const enrichedRecommendations = await Promise.all(
          recommendations.map(async (rec) => {
            let entityData = null;
            let type = null;

            // Try Destination first
            const destResponse = await fetch(`${BASE_URL}Destination/${rec.id}`, {
              method: 'GET',
              headers: {
                Authorization: `Bearer ${tokenString}`,
              },
            });

            if (destResponse.ok) {
              entityData = await destResponse.json();
              type = 'destination';
            } else {
              // Try Experience
              const expResponse = await fetch(`${BASE_URL}Experience/${rec.id}`, {
                method: 'GET',
                headers: {
                  Authorization: `Bearer ${tokenString}`,
                },
              });

              if (expResponse.ok) {
                entityData = await expResponse.json();
                type = 'experience';
              }
            }

            let coverBase64Src = null;

            if (entityData && entityData.fileNames?.length) {
              // Extract cover photo names
              const coverPhotoNames = entityData.fileNames.filter((name) =>
                name.startsWith('CoverPhoto_')
              );

              if (coverPhotoNames.length) {
                // Use the correct endpoint based on type
                const getFilesUrl =
                  type === 'destination'
                    ? `${BASE_URL}Destination/getFiles`
                    : type === 'experience'
                    ? `${BASE_URL}Experience/getFiles`
                    : null;

                if (getFilesUrl) {
                  const fileResponse = await fetch(getFilesUrl, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${tokenString}`,
                    },
                    body: JSON.stringify(coverPhotoNames),
                  });

                  if (fileResponse.ok) {
                    const files = await fileResponse.json();
                    const coverFile = files.find(
                      (f) => f.filePlaceType === FILE_PLACE_TYPE.CoverPhoto
                    );

                    if (coverFile) {
                      coverBase64Src = `data:${coverFile.mimeType};base64,${coverFile.base64Content}`;
                    }
                  }
                }
              }
            }

            return {
              ...rec,
              ...entityData, 
              type,
              coverBase64Src,
            };
          })
        );

        setRecommendations(enrichedRecommendations);
      } catch (error) {
        console.error('Failed to fetch personalized recommendations:', error);
      }
    };

    fetchRecommendations();
  }, [BASE_URL, tokenString]);


const handleSlideClick = (destination) => {
  if (destination.type === 'destination') {
    navigate('/destinations', {
      state: {
        activeComponent: 'DestinationTemplate',
        destinationId: destination.id,
      },
    });
  } else if (destination.type === 'experience') {
    navigate('/experiences', {
      state: {
        activeComponent: 'ExperienceTemplate',
        experienceId: destination.id,
      },
    });
  } else {
    console.error('Unknown destination type:', destination);
  }
};


useEffect(() => {
  const updateWidth = () => {
    if (containerRef.current) {
      const width = containerRef.current.offsetWidth;

      const { slideWidth, slideMarginRight } = getSlideDimensions();
      const totalSlideWidth = slideWidth + slideMarginRight;

      setContainerWidth(width);
      const count = Math.floor(width / totalSlideWidth) || 1;
      setVisibleSlidesCount(count);
      setCurrentIndex((current) => Math.min(current, recommendations.length - count));
    }
  };

  updateWidth();
  window.addEventListener('resize', updateWidth);
  return () => window.removeEventListener('resize', updateWidth);
}, [recommendations.length]);


  const isVisible = (index) => {
    return index >= currentIndex && index < currentIndex + visibleSlidesCount;
  };

  const nextSlide = () => {
    if (currentIndex < recommendations.length - visibleSlidesCount) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  };

const getSlideDimensions = () => {
  const width = window.innerWidth;

  if (width <= 480) {
    return { slideWidth: 160, slideMarginRight: 10 };
  } else if (width <= 768) {
    return { slideWidth: 200, slideMarginRight: 15 };
  } else if (width <= 1024) {
    return { slideWidth: 250, slideMarginRight: 20 };
  } else {
    return { slideWidth: 300, slideMarginRight: 30 };
  }
};


const { slideWidth, slideMarginRight } = getSlideDimensions();
const totalSlideWidth = slideWidth + slideMarginRight;


  // if (userRole !== 'RegisteredUser') {
  //   return null;
  // }

  return recommendations.length === 0 ? (
  <br/>
 ) : (
  <Container>
    <Header>
    <Title data-aos="zoom-in-down">{i18n.t('personalizedRecommendations')}</Title>

    <div data-aos="fade-left" >
      <Button onClick={prevSlide} disabled={currentIndex === 0}>
        &#10094;
      </Button>
      <Button
        onClick={nextSlide}
        disabled={currentIndex >= recommendations.length - visibleSlidesCount}
      >
        &#10095;
      </Button>
    </div>
    </Header>

    <CarouselContainer ref={containerRef} data-aos="fade-right">
      <Slider
        style={{
          transform: `translateX(-${currentIndex * totalSlideWidth}px)`,
          width: `${recommendations.length * totalSlideWidth}px`,
        }}
      >
        {recommendations.map((destination, index) => (
          <Slide
            key={index}
            isVisible={isVisible(index)}
            onClick={() => handleSlideClick(destination)}
          >
            <SlideImage
              src={destination.coverBase64Src || 'fallback-image.jpg'}
              alt={destination.name[currentLanguage] || destination.name.en}
            />
            <Overlay>
              <h3>{destination.name[currentLanguage] || destination.name.en}</h3>
            </Overlay>
          </Slide>
        ))}
      </Slider>
    </CarouselContainer>
  </Container>
);




};

export default PersonalisedReqs;

